import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';

import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputText } from "primereact/inputtext";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { TfiComment } from "react-icons/tfi";
import { Tooltip } from "primereact/tooltip";
import { Avatar } from "primereact/avatar";
import { Calendar } from "primereact/calendar";
import { TbHandStop } from "react-icons/tb";
import moment from "moment";
import { catchResponse, getWeekNumber } from "../../../../../utils/helperFunctions";
import { setPlantShutdown } from "../../../../../services/scenario-service";
import { error, success } from "../../../../../utils/notifications";
import { FiCommand } from "react-icons/fi";

export const ParadaPlantaModal:FC<any> = (props):JSX.Element => {

    const { visible, handleClose, id, flagChangeScenario, setFlagChangeScenario } = props 

    const [dateFrom, setDateFrom] = useState<any>(null);

    const [dateTo, setDateTo] = useState<any>(null);

    const [loadingPlantShutdown, setLoadingPlantShutdown] = useState<boolean>(false)

    const handleCloseModal = () => {
        setDateFrom(null)
        setDateTo(null)
        handleClose()
    }

    const handleAddPlantShutdown = async() => {
        try {
            setLoadingPlantShutdown(true)
            let body = {
                id_scenario: id,
                date_from: moment(dateFrom).format('DD/MM/YYYY'),
                week_from: getWeekNumber(dateFrom),
                date_to: moment(dateTo).format('DD/MM/YYYY'),
                week_to: getWeekNumber(dateTo)
              }
            const res = await setPlantShutdown(body)
            if(res.status === 200) {
                const {code, message} = res.data
                if(code === 200) {
                    success(message)
                    setFlagChangeScenario(!flagChangeScenario)
                    handleCloseModal()
                } else {
                    error(message)
                }
                setLoadingPlantShutdown(false)
            } else {
                error("Error implementando la parada a planta")
                setLoadingPlantShutdown(false)
            }

        } catch(err:any) {
            catchResponse(err)
            setLoadingPlantShutdown(false)
        }
    }

    

    

    const header = () => {
        return (
            <span>Ajustes de Parada en Planta</span>
        )
    }

    
    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button severity={'success'} disabled={!dateFrom || !dateTo || loadingPlantShutdown} label="Añadir Parada" icon={loadingPlantShutdown? <FiCommand className="loading-icon" style={{fontSize:17,marginRight:'1rem',color:'#22C55E'}} /> :<TbHandStop style={{fontSize:17,marginRight:'1rem'}} />}  onClick={handleAddPlantShutdown} outlined  />
                <Button severity={'danger'} disabled={loadingPlantShutdown} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleCloseModal} />
            </div>
        )
    }


    return (
        <div className="card flex justify-content-center">
            
            <Dialog className={"edit-modal-dialog-base"} header={header} visible={visible} style={window.screen.width > 1900? { width: '25vw',height:'45vh' } : { width: '27vw',height:'60vh' } } footer={footer} onHide={handleCloseModal}>
                <div style={{minHeight:85,display:'flex',justifyContent:'space-around',alignItems:'center',padding:'1rem',flexDirection:'column',height:'100%'}}>
                    <div className="card flex justify-content-center ajustes-modal" style={{display:'flex',flexDirection:'column'}}>
                        <label htmlFor="from" style={{fontWeight:'bold'}}>Fecha Inicio</label>
                        <Calendar locale="es" dateFormat="d/m/yy" id="from" value={dateFrom} onChange={(e:any) => setDateFrom(e.value)} showIcon />
                        <small id="from-help">
                            Introduce la fecha de inicio de parada.
                        </small>
                    </div>

                    <div className="card flex justify-content-center ajustes-modal" style={{display:'flex',flexDirection:'column'}}>
                        <label htmlFor="To" style={{fontWeight:'bold'}}>Fecha Fin</label>
                        <Calendar locale="es" dateFormat="d/m/yy" id="To" disabled={dateFrom === null} minDate={dateFrom} value={dateTo} onChange={(e:any) => setDateTo(e.value)} showIcon />
                        <small id="from-help">
                            Introduce la fecha de fin de parada.
                        </small>
                    </div>
                </div>
                
            </Dialog>
        </div>
    )
}